"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
class AxiosDataLoader {
    constructor(url, axios = axios_1.default.create()) {
        this.url = url;
        this.axios = axios;
        this.cachedFileSize = undefined;
    }
    load(start, size) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axios.get(this.url, {
                responseType: 'arraybuffer',
                headers: { "Range": `bytes=${start}-${size ? start + size - 1 : ""}` }
            });
            if (416 == response.status) {
                throw new OutOfRangeError(this.url, start, size);
            }
            if (response.data instanceof Buffer) {
                return new Uint8Array(response.data).buffer;
            }
            else {
                return response.data;
            }
        });
    }
}
exports.AxiosDataLoader = AxiosDataLoader;
class OutOfRangeError extends Error {
    constructor(resource, start, size) {
        super(`Request on ${resource} out of range. Range given: ${start}-${size || ''}`);
        this.resource = resource;
        this.start = start;
        this.size = size;
    }
}
class BufferedDataLoader {
    constructor(dataLoader, bufferSize) {
        this.dataLoader = dataLoader;
        this.bufferSize = bufferSize;
    }
    load(start, size) {
        return __awaiter(this, void 0, void 0, function* () {
            const bufferedData = this.getDataFromBuffer(start, size);
            if (undefined !== bufferedData) {
                return bufferedData;
            }
            let data;
            try {
                data = yield this.dataLoader.load(start, this.bufferSize);
            }
            catch (e) {
                if (e instanceof OutOfRangeError) {
                    data = yield this.dataLoader.load(start);
                }
                else {
                    throw e;
                }
            }
            this.buffer = {
                data: data,
                start: start,
                size: data.byteLength
            };
            if (size > data.byteLength) {
                throw new Error(`Requested ${size} bytes but only got back ${this.buffer.size}`);
            }
            return this.buffer.data.slice(0, size);
        });
    }
    getDataFromBuffer(start, size) {
        if (this.buffer === undefined) {
            return undefined;
        }
        const end = start + size;
        const bufferEnd = this.buffer.start + this.buffer.size;
        if (start > this.buffer.start && end < bufferEnd) {
            const sliceStart = start - this.buffer.start;
            const sliceEnd = sliceStart + size;
            return this.buffer.data.slice(sliceStart, sliceEnd);
        }
        return undefined;
    }
}
exports.BufferedDataLoader = BufferedDataLoader;
//# sourceMappingURL=DataLoader.js.map